import TableAction from '@/components/misc/mixinsComp/TableAction'
import { formatDisplayDate, formatDisplayDateTime, formatDisplayDateTime2 } from '@/utils/date'
import { formatDisplayNumber } from '@/utils/number'

export const tableActionHeader = { text: 'Action', align: 'center', value: 'action', sortable: false }

export const customSearch = (val, search) => {
  // Below is the default search method
  // return val !== null && ['undefined', 'boolean'].indexOf(typeof val) === -1 && val.toString().toLowerCase().indexOf(search) !== -1

  // Problem is some value like date are converted to readable format. Thus when searching, we need format these val
  let valToFilter = val

  if (typeof val === 'boolean') {
    if (val === true) {
      valToFilter = 'true yes'
    } else {
      valToFilter = 'false no'
    }
  } else if (val instanceof Date) {
    try {
      valToFilter = formatDisplayDate(val)
    } catch (err) {
      //
    }
  }

  return valToFilter !== null && ['undefined'].indexOf(typeof valToFilter) === -1 && valToFilter.toString().toLowerCase().indexOf(search.toString().toLowerCase()) !== -1
}

const tableMixin = {
  data() {
    return {
      itemsPerPage: [5, 10, 25, 50, 100],
      customSearch: customSearch,
      search: '',
      pagination: {
        // Assign sort field by default (if not it will sort the 1st field)
        sortBy: [],
        sortDesc: [false],
        page: 1,
        // Follow the 1st value of the above variable (itemsPerPage)
        itemsPerPage: 5
      },
      loading: false,
      items: [],
      headers: [],
      selected: []
    }
  },
  computed: {
    noDataText() {
      if (this.loading) {
        return 'Loading...'
      } else {
        return undefined
      }
    }
  },
  methods: {
    formatDate(val) {
      return formatDisplayDate(val)
    },
    formatDateTime(val) {
      return formatDisplayDateTime(val)
    },
    formatDateTime2(val) {
      return formatDisplayDateTime2(val)
    },
    formatBoolean(val) {
      if (val === undefined) {
        return 'No'
      } else {
        if (val === true) {
          return 'Yes'
        } else {
          return 'No'
        }
      }
    },
    formatTextLength(val) {
      if (val === null) {
        return null
      } else if (val === undefined) {
        return null
      } else {
        if (val.length > 50) {
          return val.substr(0, 50) + ' ...'
        } else {
          return val
        }
      }
    },
    formatNumber(val, scale) {
      return formatDisplayNumber(val, scale)
    }
  },
  components: {
    TableAction
  }
}

export default tableMixin
